import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { readStudioRuntimeConfig } from "./env.js";
import "./styles.css";

async function bootStudio(): Promise<void> {
  const root = document.getElementById("root");
  if (!root) {
    throw new Error("Studio root element missing");
  }
  const variant = readStudioRuntimeConfig().studioUiVariant;
  if (variant === "greenfield") {
    await import("@enrein/design-system/workspace-v1.css");
  } else {
    await import("@enrein/design-system/index.css");
  }

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootStudio();
